// REMOVED: loadAdobeAnalytics() - AEP Data Collection embed code handles this.
// REMOVED: eventVariablesMap & propVariablesMap - Their logic moves to AEP Data Collection UI.

import { fetchUserDetails, trackRefModule } from "../helpers";

const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

// Global Data Layer Object
if (typeof window !== 'undefined') {
  window.appEventData = window.appEventData || [];
}

// This function now *populates the data layer* and *triggers AEP Data Collection events*
function isMobileBrowser() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export async function getDeviceType() {
  if (navigator.userAgentData) {
    try {
      const ua = await navigator.userAgentData.getHighEntropyValues([
        'platform',
        'model',
        'mobile'
      ]);

      return ua.mobile ? "Mobile" : "PC";
    } catch (e) {
      console.error("UA data error", e);
    }
  }

  return isMobileBrowser() ? "Mobile" : "PC";
}
function getFormattedData(ms) {
    const now = ms ? new Date(ms * 1000) : new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    return `${month}/${dd}/${year}`
}

const networks = ['cnbc', 'e', 'msnbc', 'oxygen-true-crime', 'oxygen', 'peacock', 'syfy', 'usa-network', 'golfchannel']
export async function pushAdobeAnalyticsData({ eventName, config }) {
  let isAdobeEnabled = window?.app_data?.appcmsPlatform?.analytics?.adobeConfig?.enabled
  if (!isAdobeEnabled) return 
  let type = config?.type;
  let status = config?.status || null;

  if (!Array.isArray(window.appEventData)) {
    window.appEventData = [];
  }

  const now = new Date();
  const min = now.getMinutes().toString().padStart(2, '0');
  const hrs = now.getHours().toString().padStart(2, '0');
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  const year = now.getFullYear();
  let referer = trackRefModule("get");
  const pathname = window.location.pathname || '/'
  const pathSegments = pathname.split('/')
  const matchedNetwork = networks.find(network => pathSegments.includes(network)) || null
  if(eventName === "Page Load" && pathname === "/live") return  // prevent duplicate page load event for linear video player
  let event = eventName.includes("LINEAR VIDEO PLAYER") ? "Page Load" : eventName; // handle for linear video player page load event
  const eventData = {
    event: eventName.includes('Provider Sign-In:') ? 'Provider Sign-In' : event,
    app: window?.app_data?.site?.siteInternalName,
    platform: await getDeviceType(),
    minute: `${hrs}:${min}`,
    hour: `${hrs}:00`,
    day: dayNames[now.getDay()],
    date: `${month}/${day}/${year}`,
    pageName: eventName.includes('Provider Sign-In:') ? eventName : window?.pageTree,
    url: window?.location?.href,
    title : window?.pageTree
  };
  if(matchedNetwork){
    eventData.network = matchedNetwork;
  }
  if(config.videoData?.videoLength) {
     eventData.length = config.videoData?.videoLength
  }

  // add a default contenthub
  let contenthub = window?.pageTree.split(":")?.[1]?.trim().toLowerCase() || null;
  if(contenthub && !(pathSegments.includes("shows") || pathSegments.includes("browse"))) { // handle for shows or custom contenthub
    eventData.contenthub = contenthub;
  }
  if(pathSegments.includes("shows") || pathSegments.includes("browse")) {
    eventData.contenthub = "shows";
  }
  if(pathSegments.includes("tveactivate")) {
    eventData.contenthub = "Adobe Pass";
  }

  if(pathSegments.includes('sports')) {
    eventData.contenthub = 'sports'
  }

  if (config?.customEvent) {
    eventData[config.customEvent.key] = config.customEvent.value;
  }

  const { user } = await fetchUserDetails();

  const success = status === "success";

  if (config?.tveUserId) eventData.passguid = user?.tveMetadata?.tveUserId || config?.tveUserId;
  if (type === "TVE") {
    eventData.title = eventName;
    eventData.pageName = eventName;
    if (config?.network) eventData.network = config.network;
    if (status === "success" || status === "fail") {
      eventData.passauthorize = success ? "Authorized" : "Not Authorized";
      if (!success) eventData.fail = config?.authZError;
    }
    if (status === "authn") {
      if (config?.authorizationStatus) {
        eventData.passauthen = config.authorizationStatus;
      }
    }
    eventData.contenthub = "Adobe Pass";
    eventData.passnetwork = window?.app_data?.appcmsPlatform?.tveSettings?.requestorID;
    if (config?.mvpdIdentifier) eventData.passmvpd = config.mvpdIdentifier;
  } 
  else if (type === "SHOWS") {
    if (referer) eventData.module = referer;
    if (config?.network) eventData.network = config.network;
    eventData.contenthub = "movies";
    eventData.videocontent = config.videoData?.contentType;
  } 
  else if (type === "SERIES") {
    if (referer) eventData.module = referer;
    if (config?.network) eventData.network = config.network;
    eventData.contenthub = "shows";
    eventData.program = config.title;
    if(config.entitlementStatus) eventData.videostatus = config.entitlementStatus;
    eventData.videocontent = config.videoData?.contentType;
    if (config.seasonNumber) eventData.season = config.seasonNumber;
    if (config.episodeNumber) eventData.epnumber = config.episodeNumber;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  } 
  else if (type === "SERIES:VIDEO DETAILS") {
    if (referer) eventData.module = referer;
    if (config?.network) eventData.network = config.network;
    eventData.contenthub = "shows";
    eventData.program = config?.seriesName;
    eventData.episodetitle = config.title;
    eventData.videostatus = config.entitlementStatus;
    eventData.videocontent = config.videoData?.contentType;
    eventData.videoid = config.videoData?.videoId;
    if (config.seasonNumber) eventData.season = config.seasonNumber;
    if (config.episodeNumber) eventData.epnumber = config.episodeNumber;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  }

  const videoPlayerEvents = ["VIDEO PLAYER", "LINEAR VIDEO PLAYER", "LIVE VIDEO PLAYER"];
  const endCardsEvents = [
    "VIDEO PLAYER:END CARD",
    "VIDEO PLAYER:END CARD:USER PROMPT",
    "VIDEO PLAYER:END CARD:NO USER PROMPT",
    "VIDEO PLAYER:END CARD:CLOSE"
  ];

  if (videoPlayerEvents.includes(type)) {
    eventData.length = config.videoData?.videoLength || window?.lcProgrammeDetails?.programDuration || 86400;
    eventData.videocontent = config.videoData?.contentType;
    eventData.videostatus = config.entitlementStatus;
    if(config?.videoData?.contentType !== "linear") eventData.contenthub = "video-player";
    eventData.program = config.title;
    eventData.episodetitle = config.title;
    eventData.videoid = config.videoData?.videoId;
    if (config?.network) eventData.network = config.network;
    if (config.seasonNumber) eventData.season = config.seasonNumber;
    if (config.episodeNumber) eventData.epnumber = config.episodeNumber;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  }

  if (endCardsEvents.includes(type)) {
    if (type !== "VIDEO PLAYER:END CARD") {
      if (config.currentVideoTime) eventData.endcardcue = config.currentVideoTime;
    }
    eventData.length = config.videoData?.videoLength || 0;
    eventData.videocontent = config.videoData?.contentType;
    eventData.videostatus = config.entitlementStatus;
    eventData.contenthub = "video-player";
    eventData.program = config.program;
    eventData.episodetitle = config.episodeTitle;
    eventData.videoid = config.videoData?.videoId;
    eventData.endcardtype = config.endCardType || "unknown";
    if(config.pageName) eventData.pageName = config.pageName
    if(config.pageName) eventData.title = eventData.pageName;
    if (config.seasonNumber) eventData.season = config.seasonNumber;
    if (config.episodeNumber) eventData.epnumber = config.episodeNumber;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  }

  if(config?.videoData?.contentType === "linear") {
    eventData.episodetitle = window?.lcProgrammeDetails?.lcSubTitle 
    eventData.program = window?.lcProgrammeDetails?.lcProgrammeName
    eventData.videoid = window?.lcProgrammeDetails?.videotmsid
    if (window?.lcProgrammeDetails?.seriesDetails?.season) eventData.season = window?.lcProgrammeDetails?.seriesDetails?.season;
    if (window?.lcProgrammeDetails?.seriesDetails?.episode)eventData.epnumber = config.episodeNumber || window?.lcProgrammeDetails?.seriesDetails?.episode;
  }
  
  if (type === "SEARCH") {
    eventData.contenthub = "search";
    eventData.searchterm = config?.searchKeyword;
    eventData.pageName = "global:search";
    eventData.title = "global:search";
  }

  if (type === "SEARCH:SEARCH RESULTS") {
    eventData.contenthub = "search";
    eventData.searchterm = config.searchKeyword;
    eventData.pageName = "global:search:search-results";
    eventData.title = "global:search:search-results";
  }

    if (type === "SEARCH:SEARCH CLICK") {
    eventData.title = `searchClick`;
    eventData.contenthub = "search";
    eventData.pageName = `searchClick`;
    eventData.searchterm = config.searchKeyword;
    eventData.linkDetails = config.linkDetails
  }

  if(type === "SLE") {
    eventData.contenthub = config.contenthub;
    eventData.sport = config.sport;
    eventData.league = config.league;
    eventData.videostatus = config.entitlementStatus;
    eventData.videocontent = config.videoData?.contentType;
    eventData.program = config.title;
    eventData.videoid = config.videoData?.videoId;
    eventData.length = config.videoData?.videoLength
    if (config?.network) eventData.network = config.network;
    if (config.videoData?.airDate) eventData.airdate = getFormattedData(config.videoData?.airDate);
  }
  window.appEventData.push(eventData);
  console.log("Data Layer State: appEventData", window.appEventData);
  return eventData;
}


// REMOVED: trackAdobePageView() and trackAdobeEvent() - Replaced by AEP Data Collection rules.

  export function trackAdobeExtentionCustomEvents(event,payload) {
    // Trigger AEP Data Collection custom event
    if (typeof _satellite !== 'undefined' && _satellite.track) {
      _satellite.track(event,{...payload});
    }
  }
